import Vue from 'vue'
import i18n from '@/lang/lang'
import store from '@/store/index'

require('intl')
require('intl/locale-data/jsonp/es.js')
require('intl/locale-data/jsonp/en.js')

// currency
Vue.filter('currency', function (value) {
  // if (!value) return ''

  // precio con formato
  let formatter = new Intl.NumberFormat(i18n.locale, {
    style: 'currency',
    currency: store.getters.getData.currency,
    minimumFractionDigits: 2
  })
  return formatter.format(value)
})

Vue.filter('currencyFormatter', function (value, currency) {
  // precio con formato
  let formatter = new Intl.NumberFormat(i18n.locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2
  })
  return formatter.format(value)
})

// currency
Vue.filter('truncateText', function (value, max) {
  // return value + '...'
  return value.length > max ? value.substring(0, max) + '...' : value
})



// WEBPACK FOOTER //
// ./src/utils/filters.js